import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { useTranslation } from 'react-i18next';
import { FaHotel, FaStar } from 'react-icons/fa';
import LocationButton from '../ui/LocationButton';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaWallet, FaMoneyBillWave, FaCreditCard } from 'react-icons/fa';

import { BiCategoryAlt, BiErrorCircle } from "react-icons/bi";
import { addPayment } from '../../features/home/bookingSlice';
import { Link, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AiFillHome } from 'react-icons/ai';
import { fetchTripDetails, fetchTripReviews } from '../../features/admin/tripSlice';
import { FaSackDollar } from 'react-icons/fa6';
import { formatDateRange } from '../../utils/data';
import { addBookTrip } from '../../features/home/bookTripSlice';
import { useSEO } from '../../custom hooks/useSEO';
const TripCheckOut = () => {
    const { tripId } = useParams();
    const { t, i18n } = useTranslation();
    const { t: tSeo } = useTranslation("seo");

    const seo = useSEO({
        title: tSeo("tripCheckout.title"),
        description: tSeo("tripCheckout.description")
    });
    const dispatch = useDispatch<AppDispatch>();
    const [showSuccessPage, setShowSuccessPage] = useState<boolean>(false)
    const [showFailedPage, setShowFailedPage] = useState<boolean>(false)
    const [selectedMethod, setSelectedMethod] = useState('Wallet');
    const { trip, reviews } = useSelector((state: RootState) => state.tripSlice);
    const { user } = useSelector((state: RootState) => state.user);
    useEffect(() => {
        if (tripId) {
            dispatch(fetchTripDetails({ tripId: Number(tripId), userId: user?.id }));
            dispatch(fetchTripReviews(Number(tripId)))
        }
    }, [dispatch, tripId, user?.id]);



    const handlePayment = async () => {
        if (selectedMethod === 'Online' && user?.id) {
            try {
                const BookRes = await dispatch(addBookTrip({
                    userId: user?.id,
                    tripId: trip?.id,
                    paymentMethod: 'Online',
                })).unwrap();
                if (BookRes?.success) {
                    const res = await dispatch(addPayment({ userId: user?.id, bookId: BookRes.data,type:"Hall"})).unwrap();

                    if (res?.data.url) {
                        window.location.href = res.data.url;
                    }
                } else {
                    setShowFailedPage(true);
                }
            } catch (err) {
                console.error('Online payment error:', err);
            }
        }
        else if (selectedMethod === 'Cash') {
            const res = await dispatch(addBookTrip({
                userId: user?.id,
                tripId: trip?.id,
                paymentMethod: 'Cash',
            })).unwrap();
            if (res?.success) {
                setShowSuccessPage(true)
            } else {
                setShowFailedPage(true)
            }
        }
        else if (selectedMethod === 'Wallet') {
            toast.error('Wallet payment coming soon...');
        }
    };
    return (
        <div>
            {seo}
            <div className="green-hero flex-center relative main-prop xs:h-full md:h-[70vh] padding-container">
                <div className="relative z-20 text-white text-center py-10">
                    <h1 className="text-4xl font-bold mb-2">{t("trip")} {trip?.fromLocation} {t("to")} {trip?.toLocation}</h1>
                    <div className="flex items-center justify-center gap-1 text-base">
                        <AiFillHome className="mr-1 text-white text-lg" />
                        <span>{t('home')}</span>
                        <span className="mx-2">/</span>
                        <span>{t("trip")} {trip?.fromLocation} {t("to")} {trip?.toLocation}</span>
                    </div>
                </div>
            </div>
            <div className=' bg-white padding-container main-prop'>
                <div className='flex xs:flex-col md:flex-row  gap-8 '>
                    <div className='flex-1 rounded-lg border p-5 '>
                        <h3 className='text-2xl font-semibold mb-4'>{t("your-trip")}</h3>
                        <div className='flex w-full  overflow-hidden rounded-2xl border  shadow-sm"'>
                            <div className=" sm:w-48 xs:w-32  overflow-hidden  relative">
                                <img
                                    src={trip?.tripImages[0]?.url}
                                    alt={"trip"}
                                    className=" w-full h-full object-cover"
                                />
                                <span className={` absolute top-3 ${i18n.language === "ar" ? "right-3" : "left-3"}  rounded-md bg-primary px-3 py-1 text-sm text-white `}>
                                    {trip?.subCategory?.title}
                                </span>
                            </div>
                            <div className="flex flex-col justify-between flex-1 p-3">
                                <div className="flex items-start justify-between">
                                    <div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
                                        <FaStar className="text-secondry" />
                                        {trip?.rate.toFixed(1)} <span className="text-gray-400">({reviews?.length} {t("reviews")})</span>
                                    </div>
                                </div>
                                {/* Title */}
                                <h2 className="text-xl font-bold ">{trip?.fromLocation} {t("to")} {trip?.toLocation}</h2>
                                {/* Location */}
                                <p className="text-sm text-gray-500 flex items-center gap-1">
                                    <FaSackDollar className=' text-primary' /> {trip?.price} {trip?.currencyCode}
                                </p>
                            </div>
                        </div>
                        <section className="mt-10 mb-6  w-full">
                            <h2 className="text-2xl font-semibold mb-4">{t("trip-details")} </h2>
                            <p className=' text-textSecond w-full line-clamp-3 '>{trip?.details}</p>
                        </section>
                        <LocationButton link={`/place/${trip?.place?.id}/map-view`} />
                    </div>
                    <div className='flex-1 xs:p-0 md:p-5'>
                        <div className="">
                            <h2 className="text-2xl font-bold texttextSecond mb-4">{t('bookingDetails')}</h2>
                            <div className="space-y-2 justify-between pb-4 mb-4">
                                <div className="flex justify-between text-sm text-textSecond">
                                    <div className="flex gap-1 items-center">
                                        <FaCalendarAlt />
                                        <p>{t('dates')}</p>
                                    </div>
                                    <p >{trip?.fromDate && trip?.toDate && formatDateRange(trip?.fromDate, trip?.toDate)}</p>
                                </div>
                                <div className="flex justify-between text-sm text-textSecond">
                                    <div className="flex gap-1 items-center">
                                        <BiCategoryAlt />
                                        <p>{t('trip-subCatgory')}</p>
                                    </div>
                                    <p >{trip?.subCategory.title}</p>
                                </div>
                                <div className="flex justify-between text-sm text-textSecond">
                                    <div className="flex gap-1 items-center">
                                        <FaHotel />
                                        <p>{t('welcome-place')}</p>
                                    </div>
                                    <p >{trip?.place.title}</p>
                                </div>
                            </div>

                        </div>
                        <div >
                            {/* Payment Details */}
                            <div className="mb-6">
                                <h2 className="text-lg font-semibold text-secondry mb-2">{t('paymentDetails')}</h2>
                                <div className="flex text-textSecond text-sm items-center justify-between ">
                                    <div >{t('booking-price')}</div>
                                    <div >{trip?.price.toFixed(2)} {trip?.currencyCode}</div>
                                </div>

                                <div className="flex items-center justify-between ">
                                    <div >{t('totalAmount')}</div>
                                    <div className="text-orange-600 font-bold">{trip?.price.toFixed(2)} {trip?.currencyCode}</div>
                                </div>
                            </div>
                            {/* Payment Method */}
                            <div>
                                <h2 className="text-lg font-semibold text-orange-600 mb-2">{t('paymentMethod')}</h2>
                                <div className="grid xs:grid-cols-1 sm:grid-cols-2  grid-cols-3 gap-4">
                                    {/* My Wallet */}
                                    <label
                                        className={`flex items-center w-full gap-2 p-2 border rounded-lg cursor-pointer ${selectedMethod === 'wallet' ? 'border-secondry bg-orange-50' : 'border-gray-200'
                                            }`}
                                    >
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            className="accent-secondry focus:outline-none"
                                            checked={selectedMethod === 'Wallet'}
                                            onChange={() => setSelectedMethod('Wallet')}
                                        />
                                        <FaWallet className="text-2xl text-secondry" />
                                        <div className="text-sm">
                                            <div className="font-medium">{t('myWallet')}</div>
                                            <div className="text-xs text-nowrap text-textSecond">
                                                {t('available')} = <span className="text-secondry">0.00 LYD</span>
                                            </div>
                                        </div>
                                    </label>
                                    {/* Online Payment */}
                                    <label
                                        className={`flex items-center w-full gap-2 p-2 border rounded-lg cursor-pointer ${selectedMethod === 'online' ? 'border-secondry bg-orange-50' : 'border-gray-200'
                                            }`}
                                    >
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            className="accent-secondry focus:outline-none"
                                            checked={selectedMethod === 'Online'}
                                            onChange={() => setSelectedMethod('Online')}
                                        />
                                        <FaCreditCard className="text-2xl text-blue-600" />
                                        <div className="font-medium">{t('onlinePayment')}</div>
                                    </label>
                                    {/* Cash */}
                                    <label
                                        className={`flex items-center w-full gap-2 p-2 border rounded-lg cursor-pointer ${selectedMethod === 'cash' ? 'border-secondry bg-orange-50' : 'border-gray-200'
                                            }`}
                                    >
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            className="accent-secondry focus:outline-none"
                                            checked={selectedMethod === 'Cash'}
                                            onChange={() => setSelectedMethod('Cash')}
                                        />
                                        <FaMoneyBillWave className="text-2xl text-green-600" />
                                        <div className="font-medium">{t('cashPayment')}</div>
                                    </label>
                                </div>
                                <div className="mt-6">
                                    <button
                                        onClick={handlePayment}
                                        className="bg-primary text-white px-6 w-full py-3 rounded-lg hover:scale-105 transition"
                                    >
                                        {t('confirmPayment')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showSuccessPage &&
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
                        <div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
                            <div className=' flex gap-10 flex-col items-center justify-between w-full '>
                                <div className=' text-center'>
                                    <h2 className='text-xl font-semibold mb-2'>{t("successfully")}</h2>
                                    <p className=' mb-2'>{t("booked-success")}</p>
                                    <div className=' w-24'>
                                        <img src="/asset/success.png" className=' w-full' alt="success" loading='lazy' />
                                    </div>
                                </div>
                                <Link className=' text-white bg-primary rounded-lg py-2 text-center w-full' to={`${"/me/trips-bookings"}`}>{t("continue")}</Link>
                            </div>
                        </div>
                    </div>}
                {showFailedPage &&
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-5 z-50">
                        <div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-lg space-y-4">
                            <div className=' flex gap-10 flex-col items-center justify-between w-full '>
                                <div className=' flex-center flex-col text-center'>
                                    <h2 className='text-xl font-semibold mb-2'>{t("failed")}</h2>
                                    <p className=' mb-2'>{t("booked-failed")}</p>
                                    <div className=' w-16 h-16 border-[#dc26264d] rounded-full border-4 flex-center text-red-600 text-8xl'>
                                        <BiErrorCircle />
                                    </div>
                                </div>
                                <button
                                    onClick={() => setShowFailedPage(false)}
                                    className=' text-white bg-red-600 rounded-lg py-2 text-center w-full'>
                                    {t("accept")}
                                </button>
                            </div>
                        </div>
                    </div>}

            </div>
        </div>

    )
}

export default TripCheckOut


